// useHashtagPopover.js
// Hook to manage hashtag popover state

import {useMemo} from 'react';
import {useFloatingInteraction} from './useFloatingInteraction';

/**
 * Hook to manage the hashtag popover
 *
 * @returns {Object} Popover state and handlers
 */
export function useHashtagPopover() {
    const mapHashtagData = useMemo(() => {
        return (data) => ({
            id: data.id,
            label: data.label,
            docId: data.docId,
        });
    }, []);

    const hashtagInteraction = useFloatingInteraction(mapHashtagData);

    return {
        anchorEl: hashtagInteraction.anchorEl,
        anchorPosition: hashtagInteraction.anchorPosition,
        tagData: hashtagInteraction.data,
        nodePos: hashtagInteraction.nodePos,
        view: hashtagInteraction.view,
        open: hashtagInteraction.open,
        handleHashtagClick: hashtagInteraction.handleOpen,
        handleClose: hashtagInteraction.handleClose,
    };
}

